import db from "../db/database";
import {
	fetchFromBusinessCentral,
	sendToBusinessCentral,
} from "../utils/businessCentralUtils";
import { getPendingSync, isOnline } from "./syncService";

// Función para transformar un usuario al formato esperado por Business Central
const transformUserForBC = (user) => {
	// Obtener los apellidos, manejar casos donde puede no haber espacios
	const lastNameParts = user.lastName ? user.lastName.split(" ") : ["", ""];
	const firstName = lastNameParts[0] || "";
	const secondName = lastNameParts.length > 1 ? lastNameParts[1] : "";

	const transformedUser = {
		No_: user.No || "TEMP", // Si no tiene No, usamos TEMP para que BC asigne uno
		First_Family_Name: firstName,
		Second_Family_Name: secondName,
		Name: user.firstName,
		E_Mail: user.email,
		Customer_Price_Group: user.Customer_Price_Group || "",
		Company_E_Mail: user.email,
		Deleted: user.deleted,
		Password: user.password, // La contraseña se enviará si existe
		Admin: user.Admin || false, // Mapear Admin local a Admin de BC
	};

	// Crear el formato final esperado por el endpoint
	return {
		data: JSON.stringify({ Employees: [transformedUser] }),
	};
};

export const syncUsers = async () => {
	if (!isOnline()) {
		return false;
	}

	try {
		const pendingUsers = await getPendingSync("users");

		// Enviar usuarios pendientes uno por uno
		if (pendingUsers.length > 0) {
			console.log(
				`Sincronizando ${pendingUsers.length} usuarios pendientes...`
			);

			for (const user of pendingUsers) {
				try {
					// Si el usuario está marcado como eliminado, lo eliminamos directamente
					if (user.deleted) {
						await db.users.delete(user.id);
						continue;
					}

					// Enviar usuario individual a Business Central
					const response = await sendToBusinessCentral(
						"Importaciones_insertaEmpleados",
						transformUserForBC(user),
						true
					);

					// Verificar respuesta y actualizar el usuario con el No asignado por BC
					if (response && response.value) {
						const userNo = response.value;

						console.log(
							`Usuario ${user.firstName} ${user.lastName} (ID: ${user.id}) sincronizado con No: ${userNo}`
						);

						// Actualizar el usuario local con el No de BC
						await db.users.update(user.id, {
							No: userNo,
							lastModified: new Date(),
							lastSynced: new Date(),
							pendingSync: 0,
						});
					} else {
						console.error(
							`Error al sincronizar usuario ${user.id}: Respuesta inválida de BC`
						);
					}
				} catch (error) {
					console.error(`Error al sincronizar usuario ${user.id}:`, error);
				}
			}
		}

		// Obtener usuarios del servidor después de sincronizar los pendientes
		const serverUsers = await fetchFromBusinessCentral("ListaEmpleados");
		const localUsers = await db.users.toArray();

		// Mapa para buscar usuarios locales por No rápidamente
		const localUsersByNo = {};
		localUsers.forEach((user) => {
			if (user.No) {
				localUsersByNo[user.No] = user;
			}
		});

		// Actualizar usuarios existentes y añadir nuevos desde el servidor
		for (const serverUser of serverUsers) {
			// Verificar si el usuario ya existe localmente
			const localUser = localUsersByNo[serverUser.No];

			if (localUser) {
				// Actualizar usuario existente si no está pendiente de sincronización
				if (localUser.pendingSync === 0) {
					await db.users.update(localUser.id, {
						firstName: serverUser.Name,
						lastName:
							serverUser.First_Family_Name +
							" " +
							serverUser.Second_Family_Name,
						username: serverUser.Name,
						email: serverUser.E_Mail,
						Customer_Price_Group: serverUser.Customer_Price_Group || "",
						password: serverUser.Password,
						Admin: serverUser.Admin || false, // Mapear Admin de BC a Admin local
						lastModified: new Date(),
						lastSynced: new Date(),
					});
				}
			} else {
				// Añadir nuevo usuario del servidor si no existe localmente
				await db.users.add({
					No: serverUser.No,
					firstName: serverUser.Name,
					lastName:
						serverUser.First_Family_Name + " " + serverUser.Second_Family_Name,
					username: serverUser.Name,
					email: serverUser.E_Mail,
					Customer_Price_Group: serverUser.Customer_Price_Group || "",
					password: serverUser.Password,
					Admin: serverUser.Admin || false, // Mapear Admin de BC a Admin local
					lastSynced: new Date(),
					pendingSync: 0,
					deleted: false,
				});
			}
		}

		return true;
	} catch (error) {
		console.error("Error al sincronizar usuarios:", error);
		return false;
	}
};
